export default __webpack_public_path__ + "static/media/IMG_2123.c191b59e.jpg";